import snakeCase from 'voca/snake_case';

export function resourceAsParams(resourceName, resourceValues) {
  const fieldValues = {};

  Object.keys(resourceValues).forEach((key) => {
    fieldValues[snakeCase(key)] = resourceValues[key];
  });
  return { [resourceName]: fieldValues };
}

export const paramsForResourcesDeletions = ({
  frontendSideIds,
  serverSideIds,
}) => {
  const idsToDelete = serverSideIds.filter((n) => !frontendSideIds.includes(n));
  return idsToDelete.map((id) => ({ id, _destroy: true }));
};
